module.exports = __webpack_public_path__ + "static/img/DK@2x.2537d5b1.jpg";